//获取url参数
export const getQueryString = (name: string) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return "undefined";
}

//从HTML中通过input取值拿到commonTicketKey
export const getCommonTicketKey = () => {
    if (document.getElementsByClassName('commonTicketKey').length !== 0) {
        let commonTicketKey = (<HTMLInputElement>document.getElementsByClassName('commonTicketKey')[0]).value;
        commonTicketKey = commonTicketKey !== '$commonTicketKey' ? commonTicketKey : ''
        return commonTicketKey;
    }
    return undefined;
}

//从HTML中通过input取值拿到commonTicketValue
export const getCommonTicketValue = () => {
    if (document.getElementsByClassName('commonTicketValue').length !== 0) {
        let commonTicketValue = (<HTMLInputElement>document.getElementsByClassName('commonTicketValue')[0]).value;
        commonTicketValue = commonTicketValue !== '$commonTicketValue' ? commonTicketValue : ''
        return commonTicketValue;
    }
    return undefined;
}
export const getBizJson = () => {
    if (document.getElementsByClassName('getBizJson').length !== 0) {
        let bizjson = (<HTMLInputElement>document.getElementsByClassName('getBizJson')[0]).value;
        bizjson = bizjson !== '$bizjson' ? bizjson : ''
        return bizjson;
    }
    return undefined;
}

//转换时间戳
export const timestampToTime = (timestamp) => {
    let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '/';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
    let D = date.getDate() + ' ';
    let h = date.getHours() + ':';
    let m = date.getMinutes()<10?'0'+(date.getMinutes()):date.getMinutes();
    return Y+M+D+h+m
}


//排序
export const compare = (key: string) => {
    return function (value1: any, value2: any) {
        var val1 = value1[key];
        var val2 = value2[key];
        return val1 - val2;
    }
}

//提交内容去重
export const arrReduce = (arr: any, name: string) => {
    let hash: any = {}
    const attArr = arr.reduce((arr: any, current: any) => {
        if (hash[current[name]]) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i][name] === current[name]) {
                    arr.splice(i, 1);
                    arr.push(current);
                }
            }
        } else {
            hash[current[name]] = true;
            arr.push(current);
        }
        // hash[current.fieldName] ? '' : hash[current.fieldName] = true && arr.push(current);
        return arr;
    }, [])
    return attArr;
}


//获取网络环境
export const getNetworkType = () => {
    const ua = navigator.userAgent;
    // @ts-ignore
    let networkStr = ua && ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
    networkStr = networkStr.toLowerCase().replace('nettype/', '');
    let networkType;
    switch (networkStr) {
        case 'wifi':
            networkType = 'wifi';
            break;
        case '4g':
            networkType = '4g';
            break;
        case '3g':
            networkType = '3g';
            break;
        case '3gnet':
            networkType = '3g';
            break;
        case '2g':
            networkType = '2g';
            break;
        default:
            networkType = 'other';
    }
    return networkType;
}
//获取屏幕高宽
export const getScreenHeightWidth = () => {
    return {
        height: window.screen.height,
        width: window.screen.width,
    }
}
//从HTML中通过input取值拿到logUserId
export const getLogUserId = () => {
    if (document.getElementsByClassName('logUserId').length !== 0) {
        let logUserId = (<HTMLInputElement>document.getElementsByClassName('logUserId')[0]).value;
        logUserId = logUserId !== '$logUserId' ? logUserId : ''
        return logUserId;
    }else{
        return null
    }
}
//从HTML中通过input取值拿到logId
export const getLogId = () => {
    if (document.getElementsByClassName('getLogId').length !== 0) {
        let logId = (<HTMLInputElement>document.getElementsByClassName('getLogId')[0]).value;
        logId = logId !== '$logid' ? logId : ''
        return logId;
    }else{
        return null
    }
}
//获取cookie
export const getCookie = (name: string) => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return "undefined";
}
export const isAndroidIOS = () => {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //g
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        return 'app-android';
    }
    if (isIOS) {
        return 'app-ios';
    }
    if (!isAndroid && !isIOS) {
        return 'www';
    }
    return "";
}